import { render } from "./Trivia.vue?vue&type=template&id=22c963e8&scoped=true"
import script from "./Trivia.vue?vue&type=script&lang=js"
export * from "./Trivia.vue?vue&type=script&lang=js"

import "./Trivia.vue?vue&type=style&index=0&id=22c963e8&lang=css"
import "./Trivia.vue?vue&type=style&index=1&id=22c963e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c963e8"]])

export default __exports__